<template>
  <div id="app">
    <router-view />
    <AiChatFloat />
  </div>
</template>

<script>
export default {
  name: 'App',

  mounted() {
    window.addEventListener('message', this.onWindowMessage)
    // 每24小时检查一次token状态
    this.tokenCheckInterval = setInterval(() => {
      if (this.$store.getters.token) {
        // 发送一个轻量级请求来触发token续签
        this.$store.dispatch('user/getInfo').catch(() => {
          // token已失效，清除并跳转登录
          this.$store.dispatch('user/resetToken')
          this.$router.push('/login')
        })
      }
    }, 24 * 60 * 60 * 1000) // 24小时
  },

  methods: {
    onWindowMessage(event) {
      const data = event && event.data
      if (!data || data.type !== 'LOGIN_SUCCESS') return
      const redirect = data.redirect || '/'
      const ret = this.$router.push(redirect)
      if (ret && typeof ret.catch === 'function') {
        ret.catch(() => {})
      }
      setTimeout(() => {
        window.location.reload()
      }, 50)
    }
  },

  beforeDestroy() {
    if (this.tokenCheckInterval) {
      clearInterval(this.tokenCheckInterval)
    }
    window.removeEventListener('message', this.onWindowMessage)
  }
}
</script>
